/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Claimant_EmptyInputs */

const en_case_detail_claimant_empty = /** @type {(inputs: Case_Detail_Claimant_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No claimant information recorded.`)
};

const pt_br2_case_detail_claimant_empty = /** @type {(inputs: Case_Detail_Claimant_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma informação do requerente registrada.`)
};

/**
* | output |
* | --- |
* | "No claimant information recorded." |
*
* @param {Case_Detail_Claimant_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_claimant_empty = /** @type {((inputs?: Case_Detail_Claimant_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Claimant_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_claimant_empty(inputs)
	return pt_br2_case_detail_claimant_empty(inputs)
});